import { useDispatch, useSelector } from 'react-redux'
import {
  clearAllPins,
  setIsPinSelected,
  setPinnedItins,
} from '@mfs/client/listings-client/reducers/pinnedItins/pinnedItins'
import { useCallback, useMemo } from 'react'

export const usePinnedFlights = () => {
  const dispatch = useDispatch()

  const pinnedItins = useSelector((state) => state.pinnedItins.pinnedItins)
  const isPinSelected = useSelector((state) => state.pinnedItins.isPinSelected)

  const dispatchSetPinnedItins = useCallback((priceKey) => dispatch(setPinnedItins(priceKey)), [dispatch])
  const dispatchSetIsPinSelected = useCallback(
    (isSelected) => dispatch(setIsPinSelected(isSelected)),
    [dispatch]
  )
  const dispatchClearAllPins = useCallback(() => dispatch(clearAllPins()), [dispatch])

  const pinnedItinsSet = useMemo(() => new Set(pinnedItins), [pinnedItins])

  return {
    pinCount: pinnedItinsSet.size,
    pinnedItins: pinnedItinsSet,
    isPinSelected,
    setPinnedItins: dispatchSetPinnedItins,
    setIsPinSelected: dispatchSetIsPinSelected,
    clearAllPins: dispatchClearAllPins,
  }
}
